import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ExcelSvg = function ExcelSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__ae)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185C37",
    d: "M14.5 11.5 6 10v11.084a.917.917 0 0 0 .917.916h14.667a.917.917 0 0 0 .916-.916V17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21A366",
    d: "M14.5 2H6.917A.916.916 0 0 0 6 2.917V7l8.5 5 4.5 1.5 3.5-1.5V7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M6 7h8.5v5H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.084 6H6v12.5h6.084a.92.92 0 0 0 .916-.916V6.917A.92.92 0 0 0 12.084 6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.584 6.5H6V19h5.584a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.584 6.5H6V18h5.584a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.084 6.5H6V18h5.084a.92.92 0 0 0 .916-.916V7.417a.92.92 0 0 0-.916-.917",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__be)",
    d: "M11.084 6.5H1.917A.916.916 0 0 0 1 7.417v9.167c0 .506.41.916.917.916h9.167c.506 0 .916-.41.916-.916V7.417a.916.916 0 0 0-.916-.917"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m3.839 14.979 1.928-2.987L4 9.02h1.421l.964 1.9q.134.27.183.402h.013q.095-.215.2-.419l1.03-1.882h1.305l-1.812 2.953 1.858 3.004H7.774L6.66 12.894a2 2 0 0 1-.133-.279h-.016a1.3 1.3 0 0 1-.13.27l-1.146 2.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    d: "M21.584 2H14.5v5h8V2.917A.917.917 0 0 0 21.584 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    d: "M14.5 12h8v5h-8z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__be",
    x1: 2.911,
    x2: 10.089,
    y1: 5.784,
    y2: 18.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__ae"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var Excel = function Excel(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ExcelSvg
  }));
};